<template>
</template>

<script>

export default {
  name: 'AuthUrl',
  data() {
    return{

    };
  },
  created() {},
  mounted() {
    this.loading()
    let queryObj = this.getUrlCode()
    let code = queryObj.code
    let arr = (queryObj.state).split('_')
    let state = arr[0]
    let url = decodeURIComponent(arr[1])
    // console.log(`state=${state},code=${code},url=${url}`)
    window.location.href = `${url}?state=${state}&code=${code}`
    this.$toast.clear()
  },
  methods: {
    loading(){
      this.$toast.loading({
        message: '加载中...',
        loadingType: 'spinner',
        duration: 0
      })
    },
    getUrlCode() { // 截取url中的code方法
      let url = window.location.search
      let theRequest = new Object()
      if (url.indexOf("?") != -1) {
        let str = url.substr(1)
        let strs = str.split("&")
        for(let i = 0; i < strs.length; i ++) {
          theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
        }
      }
      return theRequest
    }
  },
}
</script>
<style>
.van-loading{
  text-align: center;
}
</style>
